"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRegions = void 0;

var _lodash = require("lodash");

var _modelBuilders = require("../../../utils/model-builders");

var _regionModels = require("./region-models");

var createRegions = function createRegions(raw, layer) {
  var rawRegions = (0, _lodash.get)(raw, 'Regions[0].Region');

  if (!rawRegions) {
    return [];
  }

  var headers = (0, _modelBuilders.parseKey)(raw, _regionModels.regionAttributeHeadersSchema);
  return rawRegions.map(function (region) {
    return createRegion(region, headers, layer);
  });
};

exports.createRegions = createRegions;

var createRegion = function createRegion(raw, headers) {
  var model = (0, _modelBuilders.parseModel)(raw, _regionModels.regionModel);
  var attrs = (0, _lodash.get)(raw, 'Attributes[0].Attribute', []);
  model.attributes = attrs.map(function (attr) {
    attr = (0, _modelBuilders.parseModel)(attr, _regionModels.regionAttributeModel); // Look up the header name from the header list

    attr.headerName = headers[attr.name].name;
    return attr;
  });
  return model;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/annotations/response-parsers/region.js
// module id = 234
// module chunks = 0